import React from 'react'
import { useIntl } from 'react-intl'
import CheckCircle from 'client/icons/CheckCircle'

import styles from './styles.module.css'
import IconFacility from 'client/icons/facilities/Facility'

interface IFacilityProps {
  name: string
  icon: string
  freeTag?: boolean
}

export function Facility({ name, icon, freeTag = false }: Readonly<IFacilityProps>) {
  const intl = useIntl()

  return (
    <div className={styles.facilityBase}>
      <IconFacility name={icon} defaultIcon={<CheckCircle />} />
      <p>{name}</p>
      {freeTag && <span className={styles.free}>{intl.formatMessage({ id: 'global.free' })}</span>}
    </div>
  )
}
